import React from 'react'
import {
	FaReact,
	FaBootstrap,
	FaHtml5,
	FaGitAlt,
	FaJava,
	FaNodeJs,
	FaFigma,
	FaUbuntu,
    FaGoogle,
    FaCode,
    FaAws
} from "react-icons/fa";
import { GrMysql } from "react-icons/gr";

export const frontEnd = () => [
    {
        label: "REACT.js",
        level: 100,
        icon: <FaReact className="skill-icon r" />,
    },{
        label: 'Next.js',
        level: 100,
        icon: <img className='skillImage' src={require('../../images/nextjs.png')} alt=""/>
    },{
        label: "JavaScript",
        level: 100,
        icon: <img className='skillImage' src={require('../../images/javascript.png')} alt=""/>
    },
    {
        label: "TypeScript",
        level: 100,
        icon: <img className='skillImage' src={require('../../images/ts.png')} alt=""/>

    },
    {
        label: 'Tailwind',
        level: 100,
        icon: <img className='skillImage' src={require('../../images/tailwind.png')} alt=""/>
    },
    {
        label: "BOOTSTRAP",
        level: 100,
        icon: <FaBootstrap className="skill-icon b" />,
    },{
        label: "Material UI",
        level: 100,
        icon: <img className='skillImage' src={require('../../images/mui.png')} alt=""/>
    },
    {
        label: "Redux",
        level: 100,
        icon: <img className='skillImage' src={require('../../images/redux.png')} alt=""/>
    },
    {
        label: "Sass",
        level: 100,
        icon: <img className='skillImage' src={require('../../images/sass.png')} alt=""/>
    },
    {
        label: "HTML5",
        level: 100,
        icon: <FaHtml5 className='skill-icon h'/>
    }
]
export const backEnd = () => [
    {
        label: "Java",
        level: 100,
        icon:<FaJava className="skill-icon j" />,
    },
    {
        label: "Node",
        level: 100,
        icon: <FaNodeJs className="skill-icon n" />,
    },
    {
        label: "Python",
        level: 100,
        icon: <img className='skillImage' src={require('../../images/python.png')} alt=""/>
    },
    {
        label: "C",
        level: 100,
        icon: <FaCode className="skill-icon c" />,
    },
    {
        label: "MySQL",
        level: 100,
        icon: <GrMysql className="skill-icon m" />,
    },
    {
        label: "MongoDB",
        level: 100,
        icon: <img className='skillImage' src={require('../../images/mongodb.png')} alt=""/>,
    }
]

export const tools = () => [
    
    {
        label: "AWS",
        level: 100,
        icon: <FaAws className='skill-icon j'/>
    },
    {
        label: "Google Cloud Platform",
        level: 100,
        icon: <FaGoogle className='skill-icon gcp'/>
    },
    {
        label: "Git",
        level: 100,
        icon:<FaGitAlt className="skill-icon git" />,
    },
    {
        label: "Figma",
        level: 100,
        icon: <FaFigma className="skill-icon fig" />,
    },
    {
        label: "Ubuntu",
        level: 100,
        icon: <FaUbuntu className="skill-icon linux" />,
    },
]
export const envs = () => [
    {
        label: "VSCODE (primary)",
        level: 100,
        icon:<img className='skillImage' src={require('../../images/vscode.png')} classname="skill-image" alt=""/>,
    },
    {
        label: "Eclipse",
        level: 100,
        icon:<img className='skillImage' src={require('../../images/eclipse.png')}  classname="skill-image" alt=""/>,
    },
    {
        label: "Android Studio",
        level: 100,
        icon:<img className='skillImage' src={require('../../images/android.png')}  classname="skill-image" alt=""/>
    }
]
